/**
 *
 * Meetings
 *
 */

import React from 'react';
import PropTypes from 'prop-types';

import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { Alert, Button, Card } from 'react-bootstrap';
import Spinner from 'components/Spinner/index.jsx';
import SetView from './SetView/index.jsx';
import messages from './messages.js';

export { default as Overview } from './Overview/index.jsx';
export { default as Planner } from './Planner/index.jsx';
export { default as ParentList } from './ParentList/index.jsx';
export { default as ParentPlanner } from './ParentPlanner/index.jsx';

function Meetings(props) {
  const { groupId, meetingSets } = props;
  const overviewLink = `/groups/${groupId}/meetings/list`;
  const plannerLink = `/groups/${groupId}/meetings/planner`;
  if (meetingSets.loading) {
    return <Spinner />;
  }

  return (
    <Card>
      <Card.Header className="border-0">
        <div className="d-flex justify-content-between align-items-center">
          <h2 className="card-title"><FormattedMessage {...messages.header} /></h2>
          <Button as={Link} variant="primary" to={plannerLink}><FormattedMessage {...messages.create} /></Button>
        </div>
      </Card.Header>
      <Card.Body>
        {meetingSets.list.length > 0 ? meetingSets.list.map((id) => (
          <SetView key={id} set={meetingSets[id]} link={plannerLink} overviewLink={overviewLink} />
        )) : (
          <Alert variant="info"><FormattedMessage {...messages.noMeetings} /></Alert>
        )}
      </Card.Body>
    </Card>
  );
}

Meetings.propTypes = {
  groupId: PropTypes.number,
  meetingSets: PropTypes.object,
};

export default Meetings;
